module.exports = __webpack_public_path__ + "img/LB.bc789b21.svg";